/*
 * export from ngx-lib/core/common/model
 */
export * from './public-api';
